import { JobsType } from "./videoTransformationConstants";

export const PUBLISH = Object.freeze({
  EMAIL: "email",
  SOCIAL_MEDIA: "social_media",
  CLOUD: "cloud",
  BRIGHTCOVE: "brightcove",
  INTEGRATION: "integration",
  CMS: "cms",
  FTP: "ftp",
  EMERCE: "emerce",
  DAILYMOTION: "dailymotion",
  GOOGLE_DRIVE: "googledrive",
  SFTP: "sftp",
  ASPERA: "aspera",
  SLACK: "slack",
  DROPBOX: "dropbox",
  STORYTELLER: "storyteller",
  STORIFYME: "storifyme",
  IMAGEN: "imagen",
  FRAMEIO: "frameio",
  SHADE: "shade",
});

export const PUBLISH_STATUS = {
  pending: "Pending",
  completed: "Completed",
  failed: "Failed",
  errored: "Errored",
  partially_completed: "Partially Completed",
  initiated: "Initiated",
};

export const SUCCESS_STATUS = [PUBLISH_STATUS.completed, PUBLISH_STATUS.partially_completed];
export const FAILURE_STATUS = [PUBLISH_STATUS.failed, PUBLISH_STATUS.errored];

export const PUBLISH_HISTORY_STATUS = {
  completed: "completed",
  failed: "failed",
  initiated: "initiated",
  partiallyCompleted: "partially_completed",
};

export const SOCIAL_MEDIA_PUBLISH = Object.freeze({
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram",
  LINKEDIN: "linkedin",
  YOUTUBE: "youtube",
  TWITTER: "twitter",
  TELEGRAM: "telegram",
  TIKTOK: "tiktok",
  SNAPCHAT: "snapchat",
});

export const TYPESENSE_SOCIAL_MEDIA_PLATFORMS_KEY = Object.freeze({
  youtube_post: "Youtube Post",
  youtube_short: "Youtube Shorts",
  instagram_post_and_reel: "Instagram Post & Reel",
  instagram: "Instagram Post",
  instagram_reel: "Instagram Reel",
  instagram_story: "Instagram Stories",
  facebook: "Facebook",
  linkedin: "LinkedIn",
  twitter: "X",
  telegram: "Telegram",
  tiktok: "Tiktok",
  snapchat_spotlight: "Snapchat Spotlight",
  snapchat_stories: "Snapchat All Stories",
});

export const TYPESENSE_INTEGRATION_PLATFORM_KEY = Object.freeze({
  dropbox: "Dropbox",
  frameio: "Frame.io",
  emerce: "Emerce",
  imagen: "Imagen",
  storyteller: "Storyteller",
  storifyme: "StorifyMe",
  slack: "Slack",
  dailymotion: "DailyMotion",
  shade: "Shade",
});

export const TYPESENSE_CONTENT_TYPE_KEY = Object.freeze({
  clip: "Clips",
  highlight: "Highlights",
  exportedClip: "Exported Clip",
  hlClip: "Highlight as a clip",
  variant: "Variants",
  image: "Images",
  matchVideo: "Match Video",
});

export const TYPESENSE_TYPE_KEY = Object.freeze({
  social_media: "Social Media",
  cloud: "Cloud",
  integration: "Integration",
  email: "Email",
  ftp: "FTP",
  sftp: "SFTP",
  aspera: "Aspera",
  cms: "CMS",
  brightcove: "Bright Cove",
});

export const CLOUD_PUBLISH = Object.freeze({
  AWS: "aws",
  AZURE: "azure",
  GCP: "gcp",
  OCI: "oci",
  IBM: "ibm",
  R2: "r2",
  B2: "b2",
});

export const PUBLISH_FILE_TYPE_LABEL = Object.freeze({
  json: "Clip JSON",
  xml: "XML FILE",
  edl: "EDL FILE",
  thumbnail: "Thumbnail JPEG",
  metadata: "Metadata JSON",
  mp4: "Clip",
});

export const PUBLISH_FILE_TYPE_ICON = Object.freeze({
  json: "json.svg",
  xml: "json.svg",
  edl: "json.svg",
  thumbnail: "jpg.svg",
  metadata: "json.svg",
  mp4: "clip.svg",
});

export const PUBLISH_FILE_TYPE = Object.freeze({
  thumbnail: "thumbnail",
  xml: "xml",
  custom: "custom",
  mp4: "mp4",
});

export const PUBLISH_FILE_TYPE_TO_STATE_KEY = Object.freeze({
  [PUBLISH.FTP]: "ftpPublishFiles",
  [PUBLISH.FRAMEIO]: "frameIOPublishFiles",
  [PUBLISH.INTEGRATION]: "integrationPublishFiles",
});

export const SPONSORED_VOD_ENABLE_OPTIONS = [
  {
    label: "False",
    value: "false",
  },
  {
    label: "True",
    value: "true",
  },
];

export const MULTI_AUDIO_LANGUAGES_SELECT_OPTIONS = [
  {
    label: "Hindi",
    value: "hi",
  },
  {
    label: "English",
    value: "en",
  },
  {
    label: "Tamil",
    value: "ta",
  },
];

export const PUBLISH_HISTORY_PAGE_STATIC_FILTER = [
  {
    filterLabel: "Social media accounts",
    filterKey: "platforms",
    filterArray: [
      { label: "Facebook", key: "facebook" },
      { label: "Twitter", key: "twitter" },
      { label: "LinkedIn", key: "linkedin" },
      { label: "Youtube Post", key: "youtube" },
      { label: "Youtube Shorts", key: "youtubeShorts" },
      { label: "Instagram Reels", key: "instagramReel" },
      { label: "Instagram Post", key: "instagram" },
      { label: "Instagram Stories", key: "instagramStory" },
      { label: "Telegram", key: "telegram" },
      { label: "Tiktok", key: "tiktok" },
      { label: "Snapchat All Stories", key: "snapchatSavedStory" },
      { label: "Snapchat Spotlight", key: "snapchatSpotlight" },
    ],
  },
  {
    filterLabel: "Content type",
    filterKey: "contentTypes",
    filterArray: [
      {
        label: "Clips",
        key: "clip",
      },
      {
        label: "Highlights",
        key: "highlight",
      },
      {
        label: "Match Video",
        key: "matchVideo",
      },
    ],
  },
  {
    filterLabel: "Clip type",
    filterKey: "clipTypes",
    filterArray: [{ label: "Highlight as a clip", key: "hlClip" }],
  },
  {
    filterLabel: "Publishers",
    filterKey: "publishers",
    filterArray: [
      {
        label: "UI",
        key: "UI",
      },
      {
        label: "RuleEngine",
        key: "RuleEngine",
      },
      {
        label: "PartnerAPI",
        key: "PartnerAPI",
      },
      {
        label: "Unknown",
        key: "unknown",
      },
    ],
  },
  {
    filterLabel: "Status",
    filterKey: "statuses",
    filterArray: [
      {
        label: "Partially Completed",
        key: "partially_completed",
      },
      {
        label: "Failed",
        key: "failed",
      },
      {
        label: "Published",
        key: "completed",
      },
      {
        label: "Pending",
        key: "initiated",
      },
    ],
  },
  {
    filterLabel: "Types",
    filterKey: "types",
    filterArray: [
      { label: "Email", key: "email" },
      { label: "Cloud", key: "cloud" },
      { label: "Bright Cove", key: "brightcove" },
      { label: "Integration", key: "integration" },
      { label: "Social Media", key: "social_media" },
      { label: "CMS", key: "cms" },
      { label: "FTP", key: "ftp" },
      { label: "SFTP", key: "sftp" },
      { label: "Aspera", key: "aspera" },
    ],
  },
  {
    filterLabel: "Storages",
    filterKey: "storages",
  },
  {
    filterLabel: "FTP list",
    filterKey: "ftpList",
  },
  {
    filterLabel: "SFTP list",
    filterKey: "sftpList",
  },
  {
    filterLabel: "Aspera list",
    filterKey: "asperaList",
  },
  {
    filterLabel: "Integration Platform",
    filterKey: "integrationPlatform",
  },
  {
    filterKey: "initiatedTimeRange",
    filterLabel: "Initiated between",
  },
  {
    filterKey: "publishedTimeRange",
    filterLabel: "Published between",
  },
];

export const INTEGRATION_PLATFORM = [
  {
    label: "Emerce",
    key: "emerce",
  },
  {
    label: "StorifyMe",
    key: "storifyme",
  },
  {
    label: "Slack",
    key: "slack",
  },
  {
    label: "Storyteller",
    key: "storyteller",
  },
  {
    label: "Dropbox",
    key: "dropbox",
  },
  {
    label: "DailyMotion",
    key: "dailymotion",
  },
  {
    label: "Frame.io",
    key: "frameio",
  },
  {
    label: "Imagen",
    key: "imagen",
  },
  {
    label: "Shade",
    key: "shade",
  },
];

export const INTEGRATION_PLATFORM_ITEMS = ["emerce", "storifyme", "slack", "storyteller", "dropbox", "dailymotion"];

export const DEFAULT_SLACK_TAB_ITEMS = [
  {
    key: "channels",
    label: "Channels",
    active: true,
  },
  {
    key: "people",
    label: "People",
    active: false,
  },
];

export const THIRD_PARTY_INTEGRATIONS = {
  ONEDRIVE: "Onedrive",
  EMERCE: "Emerce",
  STORIFYME: "StorifyMe",
  SLACK: "Slack",
  STORYTELLER: "Storyteller",
  DROPBOX: "Dropbox",
  DAILYMOTION: "DailyMotion",
  IMAGEN: "Imagen",
  GOOGLE_DRIVE: "Google Drive",
  FRAMEIO: "Frame.io",
  SHADE: "Shade",
};

// List of organization IDs that support old SFTP publishing flow
export const SFTP_PUBLISH_SUPPORTED_ORG_IDS = [
  "org_ff695401-9778-4434-b6fd-d43eb5120f4b",
  "org_2fd9118c-2836-4b74-8c91-2d22d8216ec1",
  "org_b8d4fe55-39fa-4b82-a976-fa5df4669309",
];

export const STORY_PUBLISH_WORKFLOW = {
  ADD_MEDIA: "add-media",
  ADD_TO_STORY: "add-to-story",
  CREATE_STORY: "create-story",
  ADD_CLIP: "add-clip",
  WIMBLEDON_MAGNIFI_IN_MATCH: "wimbledon-magnifi-in-match",
  WIMBLEDON_MAGNIFI_POST_MATCH: "wimbledon-magnifi-post-match",
};

export const SLACK_ERROR_MESSAGES = ["Slack workspace mapping not found"];
export const SLACK_ERROR_CODES = ["SlackWorkspaceMappingNotFound"];

export const SHADE_UPLOAD_SUPPORTED_MATCH_TYPES = [JobsType.FULL_MATCH_EXPORT, JobsType.PART_MATCH_EXPORT];
